import { Data_getInstance1dsensd76i3i3 as Data_getInstance } from './adapter/SavePairAssignmentsMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePairAssignmentsMutationSelections_getInstance19fjb3j0pmf0l as SavePairAssignmentsMutationSelections_getInstance } from './selections/SavePairAssignmentsMutationSelections.mjs';
import { SavePairAssignmentsMutation_VariablesAdapter_instance2ov88ys81csjl as SavePairAssignmentsMutation_VariablesAdapter_instance } from './adapter/SavePairAssignmentsMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePairAssignments) {
        this.h6g_1 = savePairAssignments;
      }
      toString() {
        return 'Data(savePairAssignments=' + this.h6g_1 + ')';
      }
      hashCode() {
        return this.h6g_1 == null ? 0 : getBooleanHashCode(this.h6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.h6g_1 == other.h6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i6g_1 = obj(Data_getInstance());
        this.j6g_1 = (new (Builder())('data', Companion_getInstance().n6d_1)).q43(SavePairAssignmentsMutationSelections_getInstance().m6g_1).i37();
        this.k6g_1 = 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
        this.l6g_1 = 'savePairAssignments';
      }
      q6d() {
        return 'mutation savePairAssignments($input: SavePairAssignmentsInput!) { savePairAssignments(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePairAssignmentsMutationClass;
function SavePairAssignmentsMutation() {
  if (SavePairAssignmentsMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.n6g_1 = input;
      }
      s6d() {
        return 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
      }
      operationId() {
        return this.s6d();
      }
      i47() {
        return Companion_getInstance_0().q6d();
      }
      t6d() {
        return 'savePairAssignments';
      }
      operationName() {
        return this.t6d();
      }
      n46(writer, customScalarAdapters, withDefaultValues) {
        SavePairAssignmentsMutation_VariablesAdapter_instance.o6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      m46() {
        return Companion_getInstance_0().i6g_1;
      }
      toString() {
        return 'SavePairAssignmentsMutation(input=' + this.n6g_1.toString() + ')';
      }
      hashCode() {
        return this.n6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsMutation()))
          return false;
        if (!this.n6g_1.equals(other.n6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsMutation', VOID, VOID, [Mutation()]);
    SavePairAssignmentsMutationClass = $;
  }
  return SavePairAssignmentsMutationClass;
}
//region block: exports
export {
  Data as Data2n9h8mazd823k,
  SavePairAssignmentsMutation as SavePairAssignmentsMutation1xoyawurksq0m,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsMutation.mjs.map
